import React from 'react';

const ActivityIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.0026 14.6666H10.0026C13.3359 14.6666 14.6693 13.3333 14.6693 9.99998V5.99998C14.6693 2.66665 13.3359 1.33331 10.0026 1.33331H6.0026C2.66927 1.33331 1.33594 2.66665 1.33594 5.99998V9.99998C1.33594 13.3333 2.66927 14.6666 6.0026 14.6666Z",
      stroke: "white",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M4.88281 9.66003L6.46948 7.60003C6.69615 7.30669 7.11615 7.25336 7.40948 7.48003L8.62948 8.44003C8.92281 8.66669 9.34281 8.61336 9.56948 8.32669L11.1095 6.34003",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
ActivityIcon.displayName = "Icons.ActivityIcon";

export { ActivityIcon };
//# sourceMappingURL=ActivityIcon.js.map
